/* eslint-disable unicorn/filename-case */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unicorn/filename-case */
/* eslint-disable @typescript-eslint/explicit-function-return-type */

import Markdown from 'react-markdown';
import { formatDate } from '../../../lib/utils';
import { SocialShare } from './SocialShare';
import OpacitySlideIn from '../../animation/opacity-slide-in';
import Accordion from '../../shared/accordion';
import remarkGfm from 'remark-gfm'; 

interface BlogDetailHeaderProps {
  Title: string;
  ShortDescription: string;
  category:string | null
  Content: string;
  publishedAt: string;
  Thumbnail: {
    url: string;
  };  
  BlogFaq: { Question: string; Answer: string; id: string }[]
}

const BlogDetails = ({postDetails}:{postDetails:BlogDetailHeaderProps}) => {

  return (
    <div className="p-6 bg-white rounded-lg shadow-md mx-auto">
      {/* Breadcrumb */}
      {/* <div className="text-sm text-gray-500">
        <a href="/blogs/1/" className="hover:underline">Blog</a>
        <a href="#" className="hover:underline">
           {postDetails.category?(<>&gt; {postDetails.category}</>):''}
           
           </a>
      </div> **/}

      {/* Breaking Label */}
      <div className="text-red-600 font-bold uppercase text-xs mt-2">
      {postDetails.category}
      </div>

      {/* Title */}
      <h1 className="mt-2 text-4xl font-bold text-gray-800 leading-tight md:line-clamp-3">
       {postDetails.Title}
      </h1>

      {/* Author Info */}
      <div className="flex items-center mt-4 text-gray-600">
        <div>
          
          <p className="text-md italic mb-3">{postDetails.ShortDescription}</p>
        </div>
      </div>

      <div className="w-full h-[28rem] overflow-hidden">
        <img alt={postDetails.Title} className="w-full h-[28rem] object-cover rounded-lg mb-4" src={postDetails.Thumbnail.url} width="100%"/>
      </div>
     
      {/* Date and Time */}
     <div className='flex justify-between items-center border-b border-zinc-400'>
     <div className="text-gray-400 text-xs mt-2">
        <p>{formatDate(postDetails.publishedAt)}</p>       
      </div>

      <SocialShare/>
     </div>
     

      <div>
      <Markdown className="rich-text-view prose-ul:list-disc prose-ol:list-decimal container px-1 mx-auto py-3" remarkPlugins={[remarkGfm]} components={{
          table: ({ node, ...props }) => (
            <table className="min-w-full border border-gray-300 rounded-lg shadow-md" {...props} />
          ),
          th: ({ node, ...props }) => (
            <th className="px-6 py-3 bg-gray-800 text-white text-left text-sm font-semibold" {...props} />
          ),
          td: ({ node, ...props }) => (
            <td className="px-6 py-4 border-b text-gray-900 hover:bg-gray-100 text-sm" {...props} />
          ),
        }}>
        {postDetails.Content}
        
      </Markdown>
      <div className="gap-14 justify-between">
          <div className="max-w-6xl">
            <h6 className="text-4xl font-bold pb-6 max-lg:text-2xl">FAQ</h6>
            <div className="flex flex-col gap-1.5">
              {postDetails.BlogFaq.map(({ Answer, Question, id }, idx) => (
                <OpacitySlideIn
                  delay={Math.min(idx * 0.01 + 0.1, 1)}
                  key={id}
                  slideFrom={{ x: -20, y: 0 }}
                >
                  <Accordion
                    defaultOpen={idx === 0}
                    slNo={`${idx + 1}`}
                    title={Question}
                  >
                    <p className="font-light">{Answer}</p>
                  </Accordion>
                </OpacitySlideIn>
              ))}
             
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default BlogDetails;
